import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  Center,
  Text,
  ModalCloseButton,
  Stack,
  Button,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import MetaMask from "../../Resources/icons/metamask/metamask";
import { setWallet } from "../../Store/data";
import { SignUser, connectWallet } from "../Ether";
import { useConnectMutation } from "../../Store/Api/ApiCall";
import { useEffect } from "react";

const ConnectWallet = ({ isOpen, onOpen, onClose }) => {
  const [Connect, results] = useConnectMutation();

  const dispatch = useDispatch();
  const handleConnect = () => {
    connectWallet().then((res) => {
      dispatch(setWallet(res));
      SignUser().then((outcome) => {
        Connect(outcome);
        console.log(outcome);
      });
      onClose();
    });
  };

  useEffect(() => {
    if (results.data) {
      console.log(results);
      localStorage.setItem("jwtToken", results.data.jwt);
    }
  }, [results]);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay>
          <ModalContent>
            <ModalHeader>
              <Center>
                <Text fontFamily={"poppins"}>Connect Your Wallet</Text>
              </Center>
              <ModalCloseButton />
            </ModalHeader>
            <ModalBody>
              <Stack>
                <Center>
                  <Text fontFamily={"metropolis"}>
                    Connect your wallet to Dapp to access feature and perks on
                    our Platform
                  </Text>
                </Center>
                <Button
                  variant={"metamask"}
                  onClick={() => {
                    handleConnect();
                  }}
                  fontFamily={"metropolis"}
                  fontWeight={"bold"}
                  p={"12"}
                  leftIcon={<MetaMask />}
                >
                  Connect MetaMask
                </Button>
              </Stack>
            </ModalBody>
          </ModalContent>
        </ModalOverlay>
      </Modal>
      ;
    </>
  );
};

export { ConnectWallet };
